export enum StoreBannerStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
